/**
 * <s-delivery-estimate> — pincode-based delivery window, dates computed in IST.
 * Ranges are calendar days from order date [fast, slow], measured 80–90th percentile.
 */
const ZONES = {
  north: { name: 'North India', r: [4, 6] },
  west: { name: 'West & Central India', r: [6, 9] },
  south: { name: 'South India', r: [7, 10] },
  east: { name: 'East India', r: [7, 10] },
  jk: { name: 'Jammu & Kashmir', r: [7, 9] },
  ne: { name: 'North-East', r: [9, 11] },
};
const DEFAULT_RANGE = [5, 9];
const VALID = /^[1-9][0-9]{5}$/;
const STORAGE_KEY = 'lachi_pin';

function zoneFor(pin) {
  const a = parseInt(pin.slice(0, 2), 10);
  const b = parseInt(pin.slice(0, 3), 10);
  if (b === 737 || b === 744 || a === 78 || a === 79) return 'ne';
  if (a === 18 || a === 19) return 'jk';
  if (a === 11 || (a >= 12 && a <= 17) || (a >= 20 && a <= 28) || (a >= 30 && a <= 34)) return 'north';
  if (a >= 36 && a <= 49) return 'west';
  if ((a >= 50 && a <= 53) || (a >= 56 && a <= 64) || (a >= 67 && a <= 69)) return 'south';
  if ((a >= 70 && a <= 77) || (a >= 80 && a <= 85)) return 'east';
  return null;
}

const dateFormat = new Intl.DateTimeFormat('en-IN', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'Asia/Kolkata' });
function fmt(plusDays) {
  return dateFormat.format(new Date(Date.now() + plusDays * 86400000));
}

class SDeliveryEstimate extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = '1';
    this.datesEl = this.querySelector('[data-eta-dates]');
    this.hintEl = this.querySelector('[data-eta-hint]');
    this.input = this.querySelector('[data-eta-pin]');
    this.msg = this.querySelector('[data-eta-msg]');
    this.querySelector('[data-eta-form]')?.addEventListener('submit', (e) => {
      e.preventDefault();
      this.apply(this.input.value.trim(), true);
    });
    this.input?.addEventListener('input', () => {
      this.input.value = this.input.value.replace(/\D/g, '').slice(0, 6);
    });
    let saved = '';
    try { saved = localStorage.getItem(STORAGE_KEY) || ''; } catch (e) { /* ignore */ }
    if (VALID.test(saved)) {
      this.input.value = saved;
      this.apply(saved, false);
    } else {
      this.show(DEFAULT_RANGE, this.dataset.hintPrompt);
    }
  }

  show(range, hint) {
    this.datesEl.textContent = `${fmt(range[0])} – ${fmt(range[1])}`;
    this.hintEl.textContent = hint;
  }

  message(text, isError) {
    this.msg.textContent = text || '';
    this.msg.hidden = !text;
    this.msg.classList.toggle('text-critical', !!isError);
  }

  apply(pin, remember) {
    this.message('');
    if (!VALID.test(pin)) {
      this.message(this.dataset.msgInvalid, true);
      return;
    }
    const zone = zoneFor(pin);
    if (!zone) {
      this.show(DEFAULT_RANGE, this.dataset.hintDefault);
      this.message(this.dataset.msgTypical);
    } else {
      const hint = this.dataset.hintZone.replace('__PIN__', pin).replace('__ZONE__', ZONES[zone].name);
      this.show(ZONES[zone].r, hint);
    }
    if (remember) {
      try { localStorage.setItem(STORAGE_KEY, pin); } catch (e) { /* ignore */ }
    }
  }
}

if (!customElements.get('s-delivery-estimate')) customElements.define('s-delivery-estimate', SDeliveryEstimate);
